// extracted by mini-css-extract-plugin
export default {"good_quality":"data-quality_good_quality__SSoKK","bad_quality":"data-quality_bad_quality__PUJyo","averege_quality":"data-quality_averege_quality__kskoe"};